module.exports = __webpack_public_path__ + "static/img/25.4a3dd39.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/25.jpg
// module id = u80A
// module chunks = 1